function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.413 17.826a7.413 7.413 0 115.857-2.867l4.73 4.73L19.69 21l-4.73-4.73a7.381 7.381 0 01-4.547 1.558zm0-1.853a5.56 5.56 0 100-11.12 5.56 5.56 0 000 11.12z",
  fill: "currentColor"
});

function SvgSearch(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMC40MTMzIDE3LjgyNjVDNi4zMTkwMyAxNy44MjY1IDMgMTQuNTA3NSAzIDEwLjQxMzNDMyA2LjMxOTAzIDYuMzE5MDMgMyAxMC40MTMzIDNDMTQuNTA3NSAzIDE3LjgyNjUgNi4zMTkwMyAxNy44MjY1IDEwLjQxMzNDMTcuODI2NSAxMi4xMjY0IDE3LjI0NTUgMTMuNzAzNyAxNi4yNjk3IDE0Ljk1OUwyMSAxOS42ODkzTDE5LjY4OTUgMjAuOTk5OEwxNC45NTkyIDE2LjI2OTVDMTMuNzAzOSAxNy4yNDU0IDEyLjEyNjQgMTcuODI2NSAxMC40MTMzIDE3LjgyNjVaTTEwLjQxMzMgMTUuOTczMUMxMy40ODM5IDE1Ljk3MzEgMTUuOTczMiAxMy40ODM4IDE1Ljk3MzIgMTAuNDEzMUMxNS45NzMyIDcuMzQyNDQgMTMuNDgzOSA0Ljg1MzE3IDEwLjQxMzMgNC44NTMxN0M3LjM0MjU4IDQuODUzMTcgNC44NTMzMSA3LjM0MjQ0IDQuODUzMzEgMTAuNDEzMUM0Ljg1MzMxIDEzLjQ4MzggNy4zNDI1OCAxNS45NzMxIDEwLjQxMzMgMTUuOTczMVoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };